import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BazisSelectComponent } from '@bazis/form/components/base/selects/select.component';

@Component({
    selector: 'bazis-select-text',
    templateUrl: './select-text.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisSelectTextComponent extends BazisSelectComponent {
    @Input()
    visibleCount?: number = null;

    allSelectedItemsShow = false;

    byCheckbox = true;
}
